import { render } from "./ButtonShow.vue?vue&type=template&id=7c1f750a&scoped=true"
import script from "./ButtonShow.vue?vue&type=script&lang=js"
export * from "./ButtonShow.vue?vue&type=script&lang=js"

import "./ButtonShow.vue?vue&type=style&index=0&id=7c1f750a&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c1f750a"]])

export default __exports__